import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { FileText, Database, Download, AlertCircle } from "lucide-react";
import { adminAPI } from "../../services/api";
import "./AdminDownloads.css";

const AdminDownloads = () => {
  const { eventId } = useParams();
  const [downloading, setDownloading] = useState(false);
  const [error, setError] = useState(null);

  const handleDownload = async (format) => {
    try {
      setDownloading(true);
      setError(null);

      const response = await adminAPI.downloadEventAttendees(eventId, format);

      // Create blob link to download
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      const filename = `attendees_${eventId}.${format}`;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Download failed:", err);
      setError("Failed to download data. Please try again.");
    } finally {
      setDownloading(false);
    }
  };

  if (!eventId) {
    return (
      <div className="admin-page-container">
        <div className="admin-content">
          <div className="error-message">
            <AlertCircle size={20} />
            <span>
              Please select an event from the dashboard to access downloads.
            </span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-page-container">
      <div className="admin-top-bar">
        <h1>Data Download</h1>
      </div>

      <div className="admin-content">
        <div className="downloads-content">
          {error && (
            <div className="error-message">
              <AlertCircle size={16} />
              <span>{error}</span>
            </div>
          )}

          <p style={{ color: "#64748b", marginBottom: "24px" }}>
            Select a format below to export the attendee list for this event.
            The export includes User ID, QR ID, Name, Phone, Email, and
            Masterclass Registrations.
          </p>

          <div className="download-cards">
            {/* <div className="download-card">
              <div className="card-icon pdf">
                <FileText size={40} />
              </div>
              <h3>Attendee List (PDF)</h3>
              <p>
                Download a printable list of attendees with profile photos.
                Optimized for security checks and offline verification.
              </p>
              <button
                className="download-btn"
                onClick={() => handleDownload("pdf")}
                disabled={downloading}
              >
                <Download size={18} />
                {downloading ? "Generating PDF..." : "Download PDF"}
              </button>
            </div> */}

            <div className="download-card">
              <div className="card-icon csv">
                <Database size={40} />
              </div>
              <h3>Attendee Data (CSV)</h3>
              <p>
                Download raw attendee data csv file. Suitable for importing into
                spreadsheet software for analysis.
              </p>
              <button
                className="download-btn secondary"
                onClick={() => handleDownload("csv")}
                disabled={downloading}
              >
                <Download size={18} />
                {downloading ? "Generating CSV..." : "Download CSV"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDownloads;
